<template>
  <img
    :src="`https://s2.googleusercontent.com/s2/favicons?domain=${value}`"
    class="rounded"
  />
</template>

<script lang="ts" setup>
defineProps<{
  value: string;
}>();
</script>
